
import React, {useEffect, useState} from 'react';
import { createRoot } from 'react-dom/client'

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';



function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

export default function DeviceAutocomplete(props) {
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [selectedValues, setSelectedValues] = useState(null);
    const [tags, setTags] = useState([]);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;

    const theme = createTheme({
        palette: {
            mode: document.documentElement.getAttribute('data-bs-theme'),
        },
    });


    
    
    const onChange = (event, values) => {
        if( values.length > 4) {
            setOpenAlert(true);
            values.splice(-1)
            return false;
        }else {
            setSelectedValues(values);
        }
    }




    useEffect(() => {
        let active = true;
        setSelectedValues(JSON.parse(props.default));

        if (!loading) {
            return undefined;
        }

        (async () => {
            if(props.type == 'smartphones' || props.type == 'smartwatches' || props.type == 'mediaplayers'  || props.type == 'headphones'){
                const response = await fetch('/api/data/devices/' +  props.type);
                //await sleep(1e3); // For demo purposes.
                const countries = await response.json();
                if (active) {
                    //setOptions(Object.keys(countries).map((key) => countries[key].item[0]));
                    setOptions(countries);
                }
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    const getBaseUrl = () => {
        let baseUrl = '/';
        switch (props.type) {
        
            case 'smartphones':
                baseUrl += 'dispositivos';
                break;

            case 'smartwatches':
                baseUrl += 'smartwatches';
                break;

            case 'mediaplayers':
                baseUrl += 'reproductores-multimedia';
                break;

            case 'headphones':
                baseUrl += 'auriculares';
                break;
        
            default:
                baseUrl += 'dispositivos';
                break;
        }
        baseUrl += '/comparar/' ;
        return baseUrl;
    }

    const buildUrl = (values) => {
        let uri = getBaseUrl();
        values.map( (v) => {
            uri += v.slug +',';
        })
        return _.trimEnd(uri, ',');
    }

    const checkMax = () => {
        if(selectedValues.length >= 4)
        {
            setOpenAlert(true);
            return true;
        }
        else  {
            setOpenAlert(false);
            return false;
        } 
    }

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway')
          return;
        setOpenAlert(false);
    };

    const handleClick = () => {
        if(selectedValues.length > 0 && selectedValues.length < 5)
            window.location.href = buildUrl(selectedValues);
    }

    return (
        <ThemeProvider theme={theme}>
            
            <div className="d-flex flex-column flex-md-row">
            <Autocomplete
                multiple
                id={props.id}
                options={options}
                getOptionLabel={(option) => option.name}
                onChange={onChange}
                //getOptionDisabled={(options) => checkMax()}
                defaultValue={JSON.parse(props.default) }
                style={{ width: '100%' }}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                //getOptionSelected={(option, value) => option.name === value.name}                
                loadingText="Cargando..."
                noOptionsText="No hemos encontrado ningun dispositivo"
                loading={loading}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label="Comparar dispositivos"
                    variant="outlined"
                    placeholder="Escribe/selecciona los dispositivos (4 max.)"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                        <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                        ),
                    }}
                    />
                )}
            />


            <button 
                className="btn btn-primary ms-md-2 ms-xs-0 mt-2 mt-md-0 fw-bold" 
                onClick={handleClick} 
                disabled={(selectedValues && selectedValues.length > 0 && selectedValues.length < 5) ? false : true}
            >
                COMPARAR
            </button>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center'  }}>
                <Alert onClose={handleCloseAlert} variant="filled" severity="error">
                    No se pueden comparar más de 4 dispositivos a la vez.
                </Alert>
            </Snackbar>
            </div>
        </ThemeProvider>
        
    );
   
}


// if (document.getElementsByClassName("deviceAutocomplete")) {
//     const list = document.getElementsByClassName("deviceAutocomplete");
//     for (const item of list) {
//         createRoot(item).render(<DeviceAutocomplete {...item.dataset} />)
//     }
// }